import { useState, useEffect, useCallback } from "react";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import LinearProgress from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import ConnectButton from "../components/connect-button";
import dropClient from "../state/dropClient.js";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useNavigate, useParams, Link } from "react-router-dom";
import A from "@mui/material/Link";
import NFTVideo from "../components/nft2026";
import { T, P } from "../components/Typography";
import theme from "../theme";
import api from "../api";
import { useWallet } from "@txnlab/use-wallet-react";
import { claimNft, checkEligibility, DEFAULT_ASSET_ID } from "../wallet/dispenser";
import { VFlex, HFlex } from "../components/layout";
import { observer } from "mobx-react-lite";
import moment from "moment";
import { countdown } from "../state/index";
import { saveLastTx } from "../state/lastTx.js";
import { SpinnerRound } from "spinners-react";
import { NFT2026ID, DROP_2026_OVER_AT, WL_2026_SHEET } from "../constants.js";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const boolToHuman = (val) =>
  val === false ? "No" : val === true ? "Yes" : val;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const D = () => <Divider sx={{ m: 4, mb: 4 }} />;

const D2 = () => <Divider sx={{ m: 2, mb: 2 }} />;

const Loading = () => (
  <Box sx={{ width: 100 }}>
    <LinearProgress />
  </Box>
);

const snackProps = {
  anchorOrigin: { vertical: "bottom", horizontal: "right" },
};

const AvailableFor = observer(({ until, countdown }) => {
  if (!until) {
    return "Not available";
  }
  if (countdown.serverNow > until) {
    console.log(countdown.serverNow, until);
    return "Expired";
  } else if (!countdown.serverNow) {
    return <Loading />;
  } else {
    const d = new Date(1000 * (until - countdown.serverNow));
    return d.toISOString().split(/[T.]/)[1];
  }
});

function getButtonLabelForStep(step) {
  return (
    <>
      <SpinnerRound size={25} color="#777" style={{ marginRight: 7 }} />
      {getButtonTextForStep(step)}
    </>
  );
}

function getButtonTextForStep(step) {
  switch (step) {
    case 1:
      return "Checking";
    case 2:
      return "awaiting approval";
    case 3:
      return "Success";
    default:
      return "Please wait";
  }
}

const TOTAL = 777;

const emptyInfo = {
  price: "FREE",
  assetID: NFT2026ID,
  total: TOTAL,
  claimCount: null,
};

const buttonLabels = [(usd) => "Receive NFT drop"];

function N({ account, discountToken, NFT }) {
  const { activeAddress, transactionSigner } = useWallet();
  const [buttonLabel, setButtonLabel] = useState(buttonLabels[0]());
  const [buttonInner, setButtonInner] = useState(buttonLabel);
  const [claimed, setClaimed] = useState(0);
  const [price, setPrice] = useState(``);
  const [availableFor, setAvailableFor] = useState(<Loading />);
  const [costUSD, setCostUSD] = useState();
  const [coopDiscount, setCoopDiscount] = useState();
  const [showWTF, setShowWTF] = useState(false);

  const navigate = useNavigate();

  const [buying, setBuying] = useState(false);
  const [txId, setTxId] = useState();
  const [groupId, setGroupId] = useState();
  const [step, setStep] = useState();
  const [t, setT] = useState();
  const [info, setInfo] = useState(emptyInfo);
  const [free, setFree] = useState(false);
  // Server-side Turnstile verification status for the drop, fed by dropClient.
  const [verifyStatus, setVerifyStatus] = useState(() =>
    dropClient.verified ? "verified" : "pending"
  );

  useEffect(() => {
    setVerifyStatus(dropClient.verified ? "verified" : "pending");
    dropClient.onStatus = setVerifyStatus;
    return () => {
      dropClient.onStatus = null;
    };
  }, []);

  useEffect(() => {
    setButtonInner(buying ? getButtonLabelForStep(step) : buttonLabel);
  }, [buying, step, buttonLabel]);

  const gotoThanks = useCallback(() => {
    if (txId || groupId)
      navigate(`/NFT/2026/thanks#${encodeURIComponent(JSON.stringify({ txId, groupId }))}`);
  }, [txId, groupId]);

  useEffect(() => {
    (async function x() {
      try {
        const data = await checkEligibility(
          account?.address,
          !!discountToken.token,
          DEFAULT_ASSET_ID
        );
        setFree(!!data.free);
        setInfo({ ...emptyInfo, ...data });
        if (data.assetID) NFT.setId(data.assetID);
        setAvailableFor(
          <AvailableFor until={countdown.bdayEnd} countdown={countdown} />
        );
      } catch (e) {
        api.error(e.message);
      }
    })();
  }, [discountToken.token, account?.address]);

  useEffect(() => {
    if (step === 2 && !t)
      setT(
        setTimeout(() => {
          api.warning(
            "Nothing in your wallet yet? Try reloading the page and start over",
            -1,
            "no-tx",
            snackProps
          );
        }, 20000)
      );
    if (step > 2 && t) {
      clearTimeout(t);
      setT();
    }
    if (step === 3) {
      if (txId || groupId) saveLastTx(2026, { txId, groupId });
      setTimeout(gotoThanks, 2000);
    }
    if (step > 2) {
      api.closeSnackbar("no-tx");
    }
  }, [step, t]);

  useEffect(() => {
    if (!account?.address && buying) {
      setBuying(false);
      api.closeSnackbar("no-tx");
    }
  }, [buying, account?.address]);

  const updateProgress = useCallback(
    (error, data) => {
      console.log("error", error);
      console.log("data", data);
      if (data?.error || error || data?.close) {
        setBuying(false);
      }
      const hasError = data?.error || error;
      if (hasError) {
        api.error(hasError, 0, "txe", snackProps);
        api.closeSnackbar("no-tx");
        api.closeSnackbar("tx");
        return;
      }
      if (data?.txId) setTxId(data.txId);
      if (data?.groupId) setGroupId(data.groupId);
      if (data?.step) {
        setStep(data.step);
        const msg = `${data.step}/3 ${data.message}`;
        api.info(msg, 0, "tx", snackProps);
      }
    },
    [txId, groupId]
  );

  const buyNFT = useCallback(() => {
    setTxId();
    setGroupId();
    setBuying(true);
    api.closeSnackbar("no-tx");
    api.closeSnackbar("tx");
    api.closeSnackbar("txe");
    (async () => {
      try {
        const { txId, groupId } = await claimNft({
          address: activeAddress,
          signer: transactionSigner,
          token: discountToken.token,
          assetId: DEFAULT_ASSET_ID,
          // App sponsors the claimedTokens box MBR so the claimer pays no extra
          // MBR (requires the dispenser app to be pre-funded).
          payMbr: false,
          onStep: updateProgress,
        });
        if (txId) setTxId(txId);
        if (groupId) setGroupId(groupId);
        console.log("claim", { txId, groupId });
      } catch (e) {
        console.error("claim err", e.message);
        setBuying(false);
        api.error(e.message, 0, "txe", snackProps);
      }
    })();
  }, [activeAddress, transactionSigner, discountToken.token, updateProgress]);
  console.log(info);
  // Once the June 12, 2026 claim window has closed there is nothing left to
  // drop or claim, so hide all the drop/wallet-connect UI and just point at the
  // whitelist spreadsheet. Use server-corrected time, falling back to the local
  // clock until the first /time response lands.
  const nowSec = countdown.serverNow ?? Math.floor(Date.now() / 1000);
  const dropOver = nowSec >= DROP_2026_OVER_AT;
  return (
    <VFlex>
      <Box sx={{ maxWidth: { sm: "300px", md: "450px" } }}>
        <Typography align="center" variant="h1" color="primary" sx={{ mb: 3 }}>
          Get 2026 Algorand Birthday NFT
        </Typography>
        <Box
          sx={{
            display: "flex",
            mb: 2,
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <NFTVideo />
        </Box>
        <HFlex sx={{ mt: 3 }}>
          <Box sx={{ flexGrow: 1 }}>Asset ID</Box>
          <Typography>{info.assetID ?? NFT.id}</Typography>
        </HFlex>
        <HFlex>
          <Box sx={{ flexGrow: 1 }}>Claimed</Box>
          <Typography>
            {info.claimCount != null ? (
              `${info.claimCount}/${TOTAL}`
            ) : (
              <Loading />
            )}
          </Typography>
        </HFlex>
        <HFlex>
          <Box sx={{ flexGrow: 1 }}>Price</Box>
          <Typography>FREE </Typography>
        </HFlex>
        <HFlex>
          <Box sx={{ flexGrow: 1 }}>Available during</Box>
          <Typography>June 12, 2026</Typography>
        </HFlex>
        <HFlex sx={{ mt: 1, alignItems: "flex-start" }}>
          <Box sx={{ flexGrow: 1 }}>Available to</Box>
          <VFlex sx={{ alignItems: "flex-end" }}>
            <Typography sx={{ textAlign: "right" }}>
              Midnight attendees 2022 - 2026
            </Typography>
            <Typography>Past NFT Buyers 2022 - 2024</Typography>
          </VFlex>
        </HFlex>

        {dropOver ? (
          <>
            <D />
            <VFlex sx={{ gap: 2 }}>
              <T sx={{ mt: 0 }}>
                The 2026 midnight drop has ended. Eligible wallets are listed in{" "}
                <A href={WL_2026_SHEET} target="_blank">this spreadsheet</A>.
              </T>
            </VFlex>
          </>
        ) : (
          <>
        {info.available && account.address && (
          <>
            <D />

            <HFlex>
              <Box sx={{ flexGrow: 1 }}>Eligible</Box>
              <Typography>
                {!account.address ? "?" : boolToHuman(info.eligible)}
              </Typography>
            </HFlex>
            <HFlex>
              <Box sx={{ flexGrow: 1 }}>Midnight 2026 Eligible</Box>
              <Typography>{info.free ? "Yes" : "No"}</Typography>
            </HFlex>
            <HFlex sx={{ alignItems: "flex-start" }}>
              <Box sx={{ flexGrow: 1 }}>Past buyer whitelist</Box>
              <Typography sx={{ textAlign: "right" }}>
                {info.hasWL ? "Yes" : "No"}
                {info.hasWL && info.hasUnclaimedWL ? (
                  <>
                    <br />
                    {info.wlQuantity} claim{info.wlQuantity === 1 ? "" : "s"} left
                  </>
                ) : null}
                {info.hasWL && !info.hasUnclaimedWL ? (
                  <>
                    <br />
                    Claimed
                  </>
                ) : null}
              </Typography>
            </HFlex>
          </>
        )}
        <D />
        {account?.address && info.available && info.eligible && (
          <>
            <VFlex>
              {txId && (
                <HFlex sx={{ mb: 2 }}>
                  {step < 3 ? "Pending" : ""} Transaction ID: {txId}
                </HFlex>
              )}
              <VFlex>
                <FormGroup sx={{ alignItems: "center" }}>
                  <Button
                    sx={{ mb: 1 }}
                    disabled={buying}
                    onClick={buyNFT}
                    variant="contained"
                    color="primary"
                  >
                    {buttonInner}
                  </Button>
                </FormGroup>
              </VFlex>
            </VFlex>
            <D />
          </>
        )}
        {account?.address &&
          info.total &&
          (!info.available || !info.eligible) && (
            <>
              <VFlex>
                {txId && (
                  <HFlex sx={{ mb: 2 }}>
                    {step < 3 ? "Pending" : ""} Transaction ID: {txId}
                  </HFlex>
                )}
                <HFlex>
                  <Button
                    disabled={true}
                    onClick={buyNFT}
                    variant="contained"
                    color="primary"
                  >
                    {info.hasClaimed ? "CLAIMED" : "Not eligible"}
                  </Button>
                </HFlex>
              </VFlex>
              <D />
            </>
          )}
        <VFlex sx={{ gap: 2 }}>
          <div>Connect wallet to check eligibility</div>
          <ConnectButton
            title={!countdown.connectOpen ? "Opens June 11 (UTC)" : undefined}
            disabled={!countdown.connectOpen}
            account={account}
            onDisconnect={api.disconnectWallet}
          />
          {account?.address && (
            <VFlex sx={{ gap: 1, alignItems: "center" }}>
              {verifyStatus === "verified" ? (
                <T variant="subtitle1" color="primary" sx={{ mt: 0, fontWeight: 600 }}>
                  ✓ Verified — you'll receive the midnight token drop
                </T>
              ) : verifyStatus === "failed" ? (
                <T variant="subtitle1" color="primary" sx={{ mt: 0, fontWeight: 600 }}>
                  Human verification failed — retrying…
                </T>
              ) : countdown.dropWindowOpen ? (
                <T variant="subtitle1" color="primary" sx={{ mt: 0, fontWeight: 600 }}>
                  Verifying you're human to receive the midnight token drop…
                </T>
              ) : (
                <T variant="subtitle1" color="primary" sx={{ mt: 0, fontWeight: 600 }}>
                  ✓ Wallet connected — keep this tab open; verification starts near midnight UTC
                </T>
              )}
            </VFlex>
          )}
          <T sx={{mt: 0}}>Or consult <A href={WL_2026_SHEET} target="_blank">this spreadsheet</A>.</T>
        </VFlex>
          </>
        )}
      </Box>
    </VFlex>
  );
}

export default observer(N);

export function printNumber(val, prefix = "") {
  if (typeof val !== "number") return val;
  return `${prefix}${val.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  })}`;
}

export function printUSD(val) {
  return printNumber(val, "$");
}
